import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';
export function useStickyUp(translateY) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sticky = _useState2[0],
    setSticky = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    y = _useState4[0],
    setY = _useState4[1];
  var handleNavigation = throttle(function () {
    if (window.scrollY > y) {
      // 'scroll down'
      if (window.scrollY >= translateY) {
        setSticky(false);
      } else {
        setSticky(true);
      }
    }
    if (window.scrollY < y) {
      // 'scroll up'
      if (window.scrollY <= translateY) {
        setSticky(false);
      } else {
        setSticky(true);
      }
    }
    setY(window.scrollY);
  }, 100);
  useEffect(function () {
    if (typeof window === 'undefined') {
      return;
    }
    var mainNavElem = document.querySelector('.corp-main-nav');
    if (mainNavElem) {
      window.addEventListener('scroll', handleNavigation);
      return function () {
        window.removeEventListener('scroll', handleNavigation);
      };
    }
  }, [handleNavigation, translateY]);
  return sticky;
}